import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useWebSocket } from "../contexts/WebSocketContext";
import api from "../api/client";
import AdminDashboard from "./admin/AdminDashboard";
import CoachDashboard from "./coach/CoachDashboard";
import StudentDashboard from "./student/StudentDashboard";
import MessagesView from "./shared/MessagesView";
import WelcomeBriefing from "../components/WelcomeBriefing";
import ChangePasswordModal from "../components/ChangePasswordModal";
import GuidedTour from "../components/GuidedTour";
import CGUReAcceptModal from "../components/CGUReAcceptModal";

// URLs externes
const ODYS_IA_URL = "https://odys-ia.odysinvest.com/login";
const ODYS_COMMUNITY_URL = "https://communaute-odys.odysinvest.com/login";

const navConfig = {
  admin: [
    { key: "dashboard", label: "Tableau de bord", icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" },
    { key: "users", label: "Utilisateurs", icon: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" },
    { key: "assignments", label: "Affectations", icon: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" },
    { key: "messages", label: "Messages", icon: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" },
    { key: "odys-ia", label: "Odys'IA", icon: "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z", external: true },
    { key: "community", label: "Communauté", icon: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z", external: true, highlight: true },
  ],
  coach: [
    { key: "dashboard", label: "Tableau de bord", icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" },
    { key: "messages", label: "Messages", icon: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" },
    { key: "odys-ia", label: "Odys'IA", icon: "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z", external: true },
    { key: "community", label: "Communauté", icon: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z", external: true, highlight: true },
  ],
  student: [
    { key: "dashboard", label: "Tableau de bord", icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" },
    { key: "messages", label: "Messages", icon: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" },
    { key: "odys-ia", label: "Odys'IA", icon: "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z", external: true },
    { key: "community", label: "Communauté", icon: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z", external: true, highlight: true },
  ],
};

const roleBadge = { admin: "badge-admin", coach: "badge-coach", student: "badge-student" };
const roleLabel = { admin: "Admin", coach: "Coach", student: "Élève" };

// ─── Notification Bell Component ──────────────────────────────────────────────
function NotificationBell() {
  const [notifications, setNotifications] = useState([]);
  const [open, setOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const { subscribe } = useWebSocket();

  // Normalize a notification: flatten `n.data.*` onto the top level so both REST
  // and WebSocket payloads render the same way in getNotifText / getNotifDetail.
  const normalize = (n) => ({ ...(n.data || {}), ...n });

  useEffect(() => {
    fetchNotifications();

    const unsubscribe = subscribe("*", (data) => {
      // chat_message is handled by MessagesView; skip to avoid duplicate toasts
      if (data.type && data.type !== "chat_message") {
        setNotifications(prev => [
          normalize({ ...data.data, type: data.type, created_at: data.timestamp, read: false }),
          ...prev,
        ]);
        setUnreadCount(prev => prev + 1);
      }
    });

    return () => unsubscribe();
  }, [subscribe]);

  const fetchNotifications = async () => {
    try {
      const res = await api.get("/notifications");
      const items = (res.data || []).map(normalize);
      setNotifications(items);
      setUnreadCount(items.filter(n => !n.read).length);
    } catch (e) {
      console.error("Failed to fetch notifications", e);
    }
  };

  const markAllRead = async () => {
    try {
      await api.put("/notifications/read-all");
      setNotifications(prev => prev.map(n => ({ ...n, read: true })));
      setUnreadCount(0);
    } catch (e) {}
  };

  const notifIcon = {
    new_message: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z",
    chat_message: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z",
    new_step: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4",
    new_substage: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4",
    stage_validated: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z",
    stage_invalidated: "M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z",
    stage_skipped: "M13 5l7 7-7 7M5 5l7 7-7 7",
    step_status_changed: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z",
    step_overdue: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
    step_due_today: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z",
    step_due_soon: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
    deadline_reminder: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z",
    inactivity_nudge: "M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9",
    new_stage_note: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z",
    new_coaching_session: "M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z",
    calendly_event: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
  };

  const shortText = (s, n = 90) => {
    if (!s) return "";
    const t = String(s).trim();
    return t.length > n ? t.slice(0, n).trim() + "…" : t;
  };

  const getNotifText = (n) => {
    switch (n.type) {
      case "new_message":
      case "chat_message":
        return `Nouveau message${n.sender_name ? ` de ${n.sender_name}` : ""}`;
      case "new_substage":
        return `Nouvelle sous-étape${n.title ? ` : ${n.title}` : ""}`;
      case "new_step":
        return `Nouvelle étape${n.step_title || n.title ? ` : ${n.step_title || n.title}` : ""}`;
      case "stage_validated":
        return `Étape validée${n.stage_title ? ` : ${n.stage_title}` : ""}`;
      case "stage_invalidated":
        return `Étape dévalidée${n.stage_title ? ` : ${n.stage_title}` : ""}`;
      case "stage_skipped":
        return `Étape passée${n.stage_title ? ` : ${n.stage_title}` : ""}`;
      case "step_status_changed":
        return `Étape mise à jour${n.step_title ? ` : ${n.step_title}` : ""}`;
      case "step_overdue":
        return `Étape en retard${n.step_title ? ` : ${n.step_title}` : ""}`;
      case "step_due_today":
        return `Échéance aujourd'hui${n.step_title ? ` : ${n.step_title}` : ""}`;
      case "step_due_soon":
        return `Échéance proche${n.step_title ? ` : ${n.step_title}` : ""}`;
      case "new_stage_note":
        return `Nouvelle note${n.coach_name ? ` de ${n.coach_name}` : (n.student_name ? ` de ${n.student_name}` : "")}`;
      case "deadline_reminder": {
        const label = n.kind === "late" ? "en retard"
          : n.kind === "j0" ? "aujourd'hui"
          : "bientôt";
        return `Sous-étape ${label}${n.title ? ` : ${n.title}` : ""}`;
      }
      case "inactivity_nudge":
        return `Ton coach t'attend${n.days ? ` (${n.days} jours d'inactivité)` : ""}`;
      case "new_coaching_session":
        return `Nouvelle session coaching${n.title ? ` : ${n.title}` : ""}`;
      case "calendly_event":
        return `Rendez-vous${n.event_type === "invitee.canceled" ? " annulé" : " planifié"}${n.event_name ? ` : ${n.event_name}` : ""}`;
      default:
        return "Nouvelle notification";
    }
  };

  const getNotifDetail = (n) => {
    if (n.type === "new_message" || n.type === "chat_message") return shortText(n.preview || n.content);
    if (n.type === "new_stage_note") return shortText(n.note_preview || n.content);
    if (n.type === "new_substage" && n.deadline) return `Échéance : ${n.deadline}`;
    if (n.type === "deadline_reminder" && n.deadline) return `Échéance : ${n.deadline}`;
    if (n.type === "inactivity_nudge") return "Reprends contact quand tu veux.";
    if (n.type === "stage_validated" || n.type === "stage_invalidated" || n.type === "stage_skipped") {
      return n.coach_name ? `Par ${n.coach_name}` : "";
    }
    if (n.type === "calendly_event") return n.event_type === "invitee.created" ? "RDV pris via Calendly" : "";
    return shortText(n.days_text || n.preview || n.description || "");
  };

  const getNotifColor = (type) => {
    if (type === "step_overdue") return "bg-red-500/20 text-red-400";
    if (type === "step_due_today") return "bg-amber-500/20 text-amber-400";
    return !type ? "" : "bg-cyan-500/20";
  };

  return (
    <div className="relative">
      <button
        data-testid="notification-bell"
        onClick={() => setOpen(!open)}
        className="relative p-2.5 rounded-xl bg-slate-800/50 border border-slate-700/50 text-slate-400 hover:text-cyan-400 hover:border-cyan-500/30 transition-all"
      >
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
        </svg>
        {unreadCount > 0 && (
          <span className="notification-badge absolute -top-1 -right-1">{unreadCount > 9 ? "9+" : unreadCount}</span>
        )}
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-12 w-80 max-h-96 overflow-y-auto bg-slate-900 border border-slate-700 rounded-2xl shadow-2xl z-50 animate-fade-in">
            <div className="p-4 border-b border-slate-700/50 flex items-center justify-between">
              <h4 className="text-sm font-semibold text-white">Notifications</h4>
              {unreadCount > 0 && (
                <button onClick={markAllRead} className="text-xs text-cyan-400 hover:text-cyan-300">
                  Tout marquer lu
                </button>
              )}
            </div>
            <div className="divide-y divide-slate-800/50">
              {notifications.length === 0 ? (
                <div className="p-6 text-center text-slate-500 text-sm">Aucune notification</div>
              ) : notifications.slice(0, 20).map((n, i) => (
                <div key={n.id || `${n.type}-${n.created_at}-${i}`}
                     data-testid={`notif-item-${n.id || i}`}
                     className={`p-4 hover:bg-slate-800/30 transition-colors ${!n.read ? "bg-cyan-500/5" : ""}`}>
                  <div className="flex gap-3">
                    <div className={`w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 ${getNotifColor(n.type)} ${!n.read && !n.type?.includes("overdue") && !n.type?.includes("due") ? "bg-cyan-500/20" : !n.read ? "" : "bg-slate-800"}`}>
                      <svg className={`w-4 h-4 ${n.type === "step_overdue" ? "text-red-400" : n.type === "step_due_today" ? "text-amber-400" : !n.read ? "text-cyan-400" : "text-slate-500"}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={notifIcon[n.type] || notifIcon.new_message} />
                      </svg>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p data-testid={`notif-title-${n.id || i}`}
                         className={`text-sm font-medium ${n.type === "step_overdue" ? "text-red-400" : n.type === "step_due_today" ? "text-amber-400" : "text-white"}`}>
                        {getNotifText(n)}
                      </p>
                      {getNotifDetail(n) && (
                        <p className="text-xs text-slate-500 mt-1 line-clamp-2">
                          {getNotifDetail(n)}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

// ─── Main Layout ──────────────────────────────────────────────────────────────
export default function DashboardLayout() {
  const { user, token, logout, mustChangePassword, showTutorial, onPasswordChanged, onTutorialComplete } = useAuth();
  const navigate = useNavigate();
  const [activeView, setActiveView] = useState("dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showBriefing, setShowBriefing] = useState(false);

  useEffect(() => {
    if (!user) navigate("/login", { replace: true });
    else if (!mustChangePassword && !showTutorial) checkShowBriefing();
  }, [user, navigate, mustChangePassword, showTutorial]);

  // Global bridge: open Messages view when another component (e.g. Coach Radar)
  // triggers a one-click relance
  useEffect(() => {
    const handler = () => setActiveView("messages");
    window.addEventListener("odys-open-messages", handler);
    return () => window.removeEventListener("odys-open-messages", handler);
  }, []);

  // Check if we should show the welcome briefing (once per day per user)
  const checkShowBriefing = () => {
    if (!user) return;
    const lastBriefingKey = `odys_briefing_${user.id}`;
    const lastBriefing = localStorage.getItem(lastBriefingKey);
    const today = new Date().toDateString();
    
    if (lastBriefing !== today) {
      setShowBriefing(true);
      localStorage.setItem(lastBriefingKey, today);
    }
  };

  const handleCloseBriefing = () => setShowBriefing(false);
  const handleOpenOdysIA = () => window.open(ODYS_IA_URL, "_blank");

  const handleLogout = () => { logout(); navigate("/login"); };

  const navItems = navConfig[user?.role] || navConfig.student;

  const handleNavClick = (item) => {
    if (item.external) {
      if (item.key === "odys-ia") {
        window.open(ODYS_IA_URL, "_blank");
      } else if (item.key === "community") {
        window.open(ODYS_COMMUNITY_URL, "_blank");
      }
    } else {
      setActiveView(item.key);
      setSidebarOpen(false);
    }
  };

  const renderContent = () => {
    if (!user) return null;
    if (activeView === "messages") return <MessagesView />;
    if (user.role === "admin") return <AdminDashboard activeTab={activeView} setActiveTab={setActiveView} />;
    if (user.role === "coach") return <CoachDashboard />;
    if (user.role === "student") return <StudentDashboard />;
    return null;
  };

  return (
    <div className="flex h-screen overflow-hidden bg-[#f5f6f8]">
      {/* CGU re-acceptance modal — blocks navigation if user is on an outdated CGU version */}
      <CGUReAcceptModal />

      {/* Welcome Briefing Modal */}
      {showBriefing && (
        <WelcomeBriefing onClose={handleCloseBriefing} onOpenAI={handleOpenOdysIA} />
      )}

      {/* Mobile overlay */}
      {sidebarOpen && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-20 lg:hidden" onClick={() => setSidebarOpen(false)} />
      )}

      {/* Sidebar - Navy theme */}
      <aside
        className={`fixed lg:static inset-y-0 left-0 z-30 w-64 flex flex-col transition-transform duration-300 sidebar-gradient border-r border-slate-700/30 ${sidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}
      >
        {/* Logo */}
        <div className="p-6 border-b border-slate-700/30">
          <div className="flex items-center gap-3">
            <img src="/logo-boussole.png" alt="Odys'Mentoring" className="w-11 h-11 drop-shadow-lg" />
            <div>
              <span className="font-bold text-lg leading-tight block" style={{ fontFamily: "Outfit, sans-serif" }}>
                <span className="text-white">Odys'</span><span className="text-amber-400">Mentoring</span>
              </span>
              <span className="text-slate-400 text-xs">Coaching Immobilier</span>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
          <p className="text-slate-500 text-xs font-semibold uppercase tracking-wider px-3 mb-3">Navigation</p>
          {navItems.map(item => (
            item.key === "odys-ia" ? (
              /* Odys'IA - Carte Or massif (sceau bancaire premium) */
              <button
                key={item.key}
                data-testid={`nav-${item.key}`}
                data-tour={`sidebar-${item.key}`}
                onClick={() => handleNavClick(item)}
                className="sidebar-external-card sidebar-external-card--gold mt-5"
              >
                <div className="sidebar-external-icon sidebar-external-icon--gold">
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d={item.icon} />
                  </svg>
                </div>
                <span className="flex-1 text-left">{item.label}</span>
                <svg className="w-3.5 h-3.5 opacity-80" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </button>
            ) : item.key === "community" ? (
              /* Communauté - Carte Teal (cachet de cire) */
              <button
                key={item.key}
                data-testid={`nav-${item.key}`}
                data-tour={`sidebar-${item.key}`}
                onClick={() => handleNavClick(item)}
                className="sidebar-external-card sidebar-external-card--teal mt-2"
              >
                <div className="sidebar-external-icon sidebar-external-icon--teal">
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d={item.icon} />
                  </svg>
                </div>
                <span className="flex-1 text-left">{item.label}</span>
                <svg className="w-3.5 h-3.5 opacity-80" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </button>
            ) : (
              <button
                key={item.key}
                data-testid={`nav-${item.key}`}
                data-tour={`sidebar-${item.key}`}
                onClick={() => handleNavClick(item)}
                className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 sidebar-item ${
                  !item.external && activeView === item.key 
                    ? "sidebar-item-active" 
                    : item.external
                      ? "text-amber-400/80 hover:text-amber-400 hover:bg-amber-500/10"
                      : ""
                }`}
              >
                <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
                  <path strokeLinecap="round" strokeLinejoin="round" d={item.icon} />
                </svg>
                <span className="flex-1 text-left">{item.label}</span>
                {item.external && (
                  <svg className="w-4 h-4 opacity-60" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                )}
              </button>
            )
          ))}
        </nav>

        {/* User Profile */}
        <div className="p-4 border-t border-slate-700/30">
          <div className="flex items-center gap-3 px-2">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-amber-500/20 to-amber-600/10 border border-amber-500/30 flex items-center justify-center flex-shrink-0">
              <span className="text-amber-400 font-bold text-sm">
                {user?.first_name?.[0]}{user?.last_name?.[0]}
              </span>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-white text-sm font-medium truncate">{user?.first_name} {user?.last_name}</p>
              <span className={`inline-block text-xs px-2 py-0.5 rounded-md font-medium ${roleBadge[user?.role]}`}>
                {roleLabel[user?.role]}
              </span>
            </div>
            <button
              data-testid="logout-btn"
              onClick={handleLogout}
              className="text-slate-400 hover:text-red-400 transition-colors p-2 rounded-lg hover:bg-red-500/10"
              title="Déconnexion"
            >
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
            </button>
          </div>
        </div>
      </aside>

      {/* Main Content - Light background */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top Bar - Light theme */}
        <header className="bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between flex-shrink-0 shadow-sm">
          <div className="flex items-center gap-4">
            <button
              className="lg:hidden p-2 rounded-xl bg-gray-100 border border-gray-200 text-gray-600 hover:text-gray-900 transition-colors"
              onClick={() => setSidebarOpen(true)}
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
            <div>
              <h1 className="text-lg font-bold text-gray-900" style={{ fontFamily: "Outfit, sans-serif" }}>
                {navItems.find(n => n.key === activeView)?.label || "Tableau de bord"}
              </h1>
              <p className="text-xs text-gray-500">Plateforme de coaching immobilier</p>
            </div>
          </div>
          
          <div className="flex items-center gap-3">
            {/* Notification Bell */}
            <NotificationBell />
            
            {/* User Badge */}
            <div className="hidden sm:flex items-center gap-2 bg-gray-100 border border-gray-200 rounded-xl px-3 py-2">
              <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-[#1a2744] to-[#2d3e5f] flex items-center justify-center">
                <span className="text-white text-xs font-bold">{user?.first_name?.[0]}</span>
              </div>
              <span className="text-sm font-medium text-gray-700">{user?.first_name} {user?.last_name}</span>
            </div>
          </div>
        </header>

        {/* Content Area - Light background */}
        <main className="flex-1 overflow-y-auto bg-[#f5f6f8] p-6 sm:p-8" data-testid="main-content">
          {renderContent()}
        </main>
      </div>

      {/* Password Change Modal - Highest priority */}
      {mustChangePassword && (
        <ChangePasswordModal onComplete={onPasswordChanged} />
      )}

      {/* Onboarding Guided Tour - After password change */}
      {!mustChangePassword && showTutorial && user && (
        <GuidedTour role={user.role} onComplete={onTutorialComplete} />
      )}
    </div>
  );
}
